import { getToken } from '../../services/tokenService';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Formats acceptés
export const ACCEPTED_VIDEO_EXT = ['mp4', 'mpeg', 'mpg', 'mov', 'avi', 'webm', 'wmv', 'mkv'];
export const ACCEPTED_IMAGE_EXT = ['jpg', 'jpeg', 'png', 'webp', 'heic', 'heif'];
export const ACCEPTED_EXT = [...ACCEPTED_VIDEO_EXT, ...ACCEPTED_IMAGE_EXT];
export const ACCEPTED_FORMATS_ATTR = ACCEPTED_EXT.map((e) => `.${e}`).join(',') + ',image/*,video/*';
export const MAX_FILE_SIZE_MB = 10;
export const PAGE_SIZE = 24;

export const isImageFile = (item) => {
  if (!item) return false;
  if (item.mime_type?.startsWith('image/')) return true;
  const name = (item.original_filename || item.nom || item.filename || '').toLowerCase();
  return ACCEPTED_IMAGE_EXT.some((ext) => name.endsWith(`.${ext}`));
};

export const isVideoFile = (item) => {
  if (!item) return false;
  if (item.mime_type?.startsWith('video/')) return true;
  const name = (item.original_filename || item.nom || item.filename || '').toLowerCase();
  return ACCEPTED_VIDEO_EXT.some((ext) => name.endsWith(`.${ext}`));
};

export const formatFileSize = (bytes) => {
  if (!bytes) return 'N/A';
  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(kb < 10 ? 1 : 0)} KB`;
  const mb = kb / 1024;
  if (mb < 1024) return `${mb.toFixed(1)} MB`;
  return `${(mb / 1024).toFixed(1)} GB`;
};

export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleDateString('fr-FR', {
    day: '2-digit', month: 'short', year: 'numeric'
  });
};

export const getMediaUrl = (item) => {
  const token = getToken();
  const tokenParam = token ? `?token=${encodeURIComponent(token)}&mode=view` : '?mode=view';
  return `${BACKEND_URL}/api/ged/download/${item.id}${tokenParam}`;
};

export const getThumbnailUrl = (item) => {
  if (!item.thumbnail_path) return null;
  const token = getToken();
  return `${BACKEND_URL}/api/ged/thumbnail/${item.id}?token=${encodeURIComponent(token || '')}`;
};

export const getMediaName = (item) => item.original_filename || item.nom || item.filename || 'fichier';
